module.exports = __webpack_public_path__ + "static/media/fly0126.fada4a5a.webp";